import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";


export class ArchiveDesertApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'archive-desert'
    }


   




}